import './style.scss';
import LegalPageHeader from './LegalPageHeader';

function PrivacyPage() {
    return (
        <div className="vivo-legal-wrap">
            <LegalPageHeader />
            <section className="section" style={{ padding: '2rem 0 0' }}>
                <iframe
                    src="https://app.termly.io/policy-viewer/policy.html?policyUUID=72de9951-5606-465b-96ec-8058d288ab71"
                    title="Privacy Policy"
                    style={{ width: '100%', minHeight: '85vh', border: 'none', display: 'block' }}
                />
            </section>
        </div>
    );
}

export default PrivacyPage;
